import { v2SitesDetailsDetail } from '@on3/api';
import type { IPlansProps } from '@on3/ui-lib/api/schema/custom-contracts';
import { proxyApi } from '@on3/ui-lib/index';
import { withAuthentication } from '@on3/ui-lib/src/hocs/withAuthentication';
import { withValidUrl } from '@on3/ui-lib/src/hocs/withValidUrl';
import type { AxiosError } from 'axios';
import { SubscribeLayout } from 'components/Layouts/SubscribeLayout';
import { JoinPage } from 'components/Subscription/JoinPage/JoinPage';
import type { GetServerSideProps } from 'next';
import { usePathname } from 'next/navigation';
import { getFulfilledData } from 'utils/getFulfilledData';
import { createCanonicalUrl, createTitle } from 'utils/meta';

const TeamJoinPage = ({ ...props }: IPlansProps) => {
  const { currentSite } = props?.siteData || {};

  const pathname = usePathname();
  const canonical = createCanonicalUrl(pathname);
  const title = createTitle(
    'Subscribe to the',
    currentSite?.organization?.knownAs ?? currentSite?.organization?.name,
    currentSite?.organization?.mascot,
    '| On3.com',
  );

  return (
    <SubscribeLayout
      {...props}
      background="#F5F6F9"
      canonical={canonical}
      noPadding={true}
      title={title}
    >
      <JoinPage siteDetails={props?.siteDetails} />
    </SubscribeLayout>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const siteData = await withValidUrl.isValid(ctx);
  const userData = await withAuthentication.isAuth(ctx);

  if (!siteData?.currentSite?.key) {
    return {
      notFound: true,
    };
  }

  const siteKey = siteData.currentSite.key;

  try {
    const [siteDetails] = await Promise.allSettled([
      v2SitesDetailsDetail(proxyApi, siteKey),
    ]);

    return {
      props: {
        pageType: 'user',
        siteData,
        userData: userData || {},
        siteDetails: getFulfilledData(siteDetails),
      },
    };
  } catch (error) {
    const err: AxiosError<unknown> = error as AxiosError<unknown>;

    console.log(err.message);

    return { props: {} };
  }
};

export default withValidUrl(TeamJoinPage);
